import {connect} from 'react-redux';
import VirtualEvent from 'shared/VirtualEvent.jsx';
import {handleBowlerOwnedVirtualEventAddClick} from './actions';
import {updateBowlerOwnedVirtualEventQuantity} from './actionTypes';

const mapStateToProps = state => ({
  ...state.admin.schedule.allEvent,
  virtualEvents: state.admin.schedule.virtualEvents,
  showAllEvent: true
});

const mapDispatchToProps = dispatch => ({
  onAddClick: item => dispatch(handleBowlerOwnedVirtualEventAddClick(item)),
  onQuantityChange: (virtualEventId, quantity) => dispatch(updateBowlerOwnedVirtualEventQuantity(virtualEventId, quantity))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEvent);



// WEBPACK FOOTER //
// ./src/features/admin/schedule/VirtualEventContainer.jsx